/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React, { useState } from "react"
import {
    TitleSection,
    ModalTitle,
    ContentSection,
    FooterSection,
    Column,
    Label,
    Color,
    Row,
    Element,
    Button,
    Icon,
    isSmallMobileScreen,
} from "trux"

export const PlayerEmail = ({
    loggedInUser,
    onSelected,
    onBackClick,
    updatePlayerEmail,
}) => {
    const [selected, setSelected] = useState(null)
    const [error, setError] = useState(null)

    const onContinue = () => {
        if (!selected) {
            // eslint-disable-next-line quotes
            setError('You must select "Yes" or "No" to continue')
        } else {
            if (selected === "no") {
                updatePlayerEmail()
            }
            onSelected(selected)
        }
    }

    const onButtonClick = (buttonId) => {
        if (error) setError(null)
        setSelected(buttonId)
    }

    return (
        <>
            <TitleSection onBackClick={onBackClick}>
                <ModalTitle content={"Player email?"} />
            </TitleSection>
            <ContentSection>
                <Column center span="12" className="form">
                    <Label
                        center
                        type={Label.Type.Body}
                        color={Color.Charcoal40}
                        content={`Does ${loggedInUser.first_name} have a personal email?`}
                        marginBottom="2"
                        marginTop="2"
                    />
                    <Element className="text-contents">
                        <Label
                            center
                            small
                            type={Label.Type.Body}
                            color={Color.Charcoal40}
                            content="Adding player emails makes accessing their Trace video and connecting accounts across teams easier."
                            marginBottom="8"
                        />
                    </Element>
                    <Row marginBottom="8">
                        <Element
                            marginRight="4"
                            id="yes"
                            className={`big-button ${
                                selected === "yes" ? "selected" : ""
                            }`}
                            onClick={() => onButtonClick("yes")}
                        >
                            <Element className="contents">
                                {selected === "yes" && (
                                    <Element className="selected-check">
                                        <Icon
                                            size={16}
                                            type={Icon.Type.Check}
                                        />
                                    </Element>
                                )}
                                <Label width="128px" content="Yes" />
                            </Element>
                        </Element>
                        <Element
                            id="no"
                            className={`big-button ${
                                selected === "no" ? "selected" : ""
                            }`}
                            onClick={() => onButtonClick("no")}
                        >
                            <Element className="contents">
                                {selected === "no" && (
                                    <Element className="selected-check">
                                        <Icon
                                            size={16}
                                            type={Icon.Type.Check}
                                        />
                                    </Element>
                                )}
                                <Label width="128px" content="No" />
                            </Element>
                        </Element>
                    </Row>
                    {error && (
                        <Label
                            bold
                            color={Color.Error}
                            content={error}
                            marginBottom="8"
                        />
                    )}
                    {!isSmallMobileScreen() && (
                        <Button
                            type={Label.Type.Heading5}
                            onClick={onContinue}
                            span="12"
                            className="button"
                            content={
                                <Row>
                                    <Label
                                        type={Label.Type.InnerButton}
                                        content="Continue"
                                        marginRight="2"
                                    />{" "}
                                    <Icon
                                        size={16}
                                        type={Icon.Type.CheveronRight}
                                    />
                                </Row>
                            }
                        />
                    )}
                </Column>
            </ContentSection>
            {isSmallMobileScreen() && (
                <FooterSection>
                    <Button
                        type={Label.Type.Heading5}
                        onClick={onContinue}
                        span="12"
                        className="button"
                        content={
                            <Row>
                                <Label
                                    type={Label.Type.InnerButton}
                                    content="Continue"
                                    marginRight="2"
                                />{" "}
                                <Icon
                                    size={16}
                                    type={Icon.Type.CheveronRight}
                                />
                            </Row>
                        }
                    />
                </FooterSection>
            )}
        </>
    )
}
